// Rebrand 2027. Whether a page renders it is decided once per request on the server
// (server/services/brand/brand-service.js) and reaches React as `isNewBrand` in GenericConfigContext.
// Set on <html> of every page rendered with the new brand, React and raw generated pages alike, so
// brand-wide CSS (the new font, styles/brand-2027.scss) is scoped by one selector.
const NEW_BRAND_ATTRIBUTE_NAME = "data-brand";
const NEW_BRAND_ATTRIBUTE_VALUE = "rebrand-2027";
// The current monday.com logo, the one the new brand replaces. constants/links.js takes MONDAY_LOGO_SRC
// from here, so the swap in services/brand-service.js can't drift from the logo the site actually draws.
const MONDAY_LOGO_SRC = "/static/img/monday-logo-x2.png";
const MONDAY_LOGO_WHITE_SRC = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/monday-logo-white.png";
// The HR new-joiners site's header logo (wordmark + "Hello" bubble), re-exported by constants/links.js too.
const MONDAY_WELCOME_NEW_JOINERS_LOGO_SRC = "/static/img/monday-welcome-new-joiners-logo-x2.png";
// The kit's wordmark, padded to the old monday-logo-x2.png's ink band so it fills the same box at the
// same CSS height.
const NEW_BRAND_LOGO_SRC = "/static/img/rebrand-2027/monday-logo.svg";
const NEW_BRAND_LOGO_WHITE_SRC = "/static/img/rebrand-2027/monday-logo-white.svg";
// Same canvas as the old welcome logo: the new wordmark in the old one's band, the "Hello" bubble in the
// mark's purple with the word outlined from monday Saans SemiBold (a static vector logo, per the license).
const NEW_BRAND_WELCOME_NEW_JOINERS_LOGO_SRC = "/static/img/rebrand-2027/monday-welcome-new-joiners-logo.svg";
// Served from origin as-is, never through Cloudinary: its /static auto-upload mapping 404s on these
// SVGs (verified on staging), and f_auto/q_auto has nothing to do for a vector logo anyway.
const NEW_BRAND_LOGO_SRCS = [
    NEW_BRAND_LOGO_SRC,
    NEW_BRAND_LOGO_WHITE_SRC,
    NEW_BRAND_WELCOME_NEW_JOINERS_LOGO_SRC
];
const isNewBrandLogoSrc = (src)=>NEW_BRAND_LOGO_SRCS.includes(src);
// Rebrand 2027 CTAs are black instead of purple: filled, outline and secondary (arrow) buttons alike.
// These are the purple CTA color names (styles/color-consts.js / styles/colors.js) and the hex values
// they resolve to, for the pricing cards, which pass hex instead of names. `Black` is the #000000 name
// (BRAND_BLACK_BACKGROUND_COLOR); `black` is #333333 text grey, so it would be the wrong swap.
// Left alone on purpose: workos-iris-light (a background tint), indigo, and brand-dark-blue (same hex
// as brand-iris, but named and used as a blue).
const OLD_BRAND_CTA_COLOR_NAMES = [
    "workos-iris",
    "workos-iris-dark",
    "electric-blue",
    "Brand & WM Primary Color",
    "brand-wm-primary-color",
    "iris",
    "iris-hover",
    "brand-iris",
    "brand-iris-hover",
    "gradiant-workos-iris",
    "gradiant-workos-iris-hover"
];
const OLD_BRAND_CTA_HEX_COLORS = [
    "#6161ff",
    "#5034ff",
    "#595ad4",
    "#3c3ed6",
    "#3335c7"
];
const NEW_BRAND_CTA_COLOR_NAME = "Black";
const NEW_BRAND_CTA_HEX_COLOR = "#000000";
module.exports = {
    NEW_BRAND_ATTRIBUTE_NAME,
    NEW_BRAND_ATTRIBUTE_VALUE,
    MONDAY_LOGO_SRC,
    MONDAY_LOGO_WHITE_SRC,
    MONDAY_WELCOME_NEW_JOINERS_LOGO_SRC,
    NEW_BRAND_LOGO_SRC,
    NEW_BRAND_LOGO_WHITE_SRC,
    NEW_BRAND_WELCOME_NEW_JOINERS_LOGO_SRC,
    isNewBrandLogoSrc,
    OLD_BRAND_CTA_COLOR_NAMES,
    OLD_BRAND_CTA_HEX_COLORS,
    NEW_BRAND_CTA_COLOR_NAME,
    NEW_BRAND_CTA_HEX_COLOR
};
